"use client";
import { useEffect, useLayoutEffect } from "react";
//#region src/utils/use-safe-layout-effect.ts
var useSafeLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
//#endregion
export { useSafeLayoutEffect };
